module.exports = __webpack_public_path__ + "static/media/user-remove-dark.85b41197.svg";